import { createAsyncThunk } from "@reduxjs/toolkit";
import * as URL from "../../helpers/url_helper";
import { get, post, put, del } from "../../helpers/api_helper";

export const getInfulencerList = createAsyncThunk(
  "getInfulencerList",
  async ({ data, callback }, Thunk) => {
    try {
      let response = await post(URL.GET_INFLUENCER_LIST, data);
      callback && callback(null, response.data);
      return response;
    } catch (error) {
      callback && callback(error?.data?.message || error.message || error);
      return Thunk.rejectWithValue(error);
    }
  },
);

export const getInfulencerWithdrawalsList = createAsyncThunk(
  "getInfulencerWithdrawalsList",
  async ({ data, callback }, Thunk) => {
    try {
      console.log(data, "datafilter");
      const response = await get(
        `${URL.GET_INFLUENCER_WITHDRAW_LIST}?status=${data.status}`,
      );

      callback && callback(null, response.data);
      return response.data;
    } catch (error) {
      callback &&
        callback(error?.response?.data?.message || error.message || error);

      return Thunk.rejectWithValue(error?.response?.data || error.message);
    }
  },
);

export const editUserStatus = createAsyncThunk(
  "editUserStatus",
  async ({ id, data, callback }, Thunk) => {
    try {
      let response = await put(URL.UPDATE_USER_STATUS + id, data);
      callback && callback(null, response);
      return response;
    } catch (error) {
      callback && callback(error.message, null);
      return Thunk.rejectWithValue(error);
    }
  },
);

export const getInfluencerDetail = createAsyncThunk(
  "getInfluencerDetail",
  async ({ data, callback }, Thunk) => {
    try {
      let response = await get(URL.GET_INFLUENCER_DETAIL + data.id);
      callback && callback(null, response);
      return response;
    } catch (error) {
      callback && callback(error.message, null);
      return Thunk.rejectWithValue(error);
    }
  },
);

export const updateInfluencerRequest = createAsyncThunk(
  "updateInfluencerRequest",
  async ({ id, data, callback }, Thunk) => {
    try {
      let response = await put(URL.UPDATE_REQUEST_STATUS + id, data);
      callback && callback(null, response);
      return response;
    } catch (error) {
      callback && callback(error.message, null);
      return Thunk.rejectWithValue(error);
    }
  },
);

export const updateInfluencerWithdrawReq = createAsyncThunk(
  "updateInfluencerWithdrawReq",
  async ({ id, data, callback }, Thunk) => {
    try {
      const response = await post(
        `${URL.UPDATE_WITHDRAW_REQUEST_STATUS}/${id}/process`,
        data,
      );

      callback && callback(null, response.data);

      return response.data; // ✅ important
    } catch (error) {
      const errMsg =
        error?.response?.data?.message ||
        error.message ||
        "Something went wrong";

      callback && callback(errMsg, null);

      return Thunk.rejectWithValue(errMsg);
    }
  },
);
